import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";
import { captureOrder } from "../../../../network/ApiAxios";

const ManagementInformation = (props) => {
    const payment = props.payment
    const formDisabled = props.formDisabled
    const [detail, setDetail] = useState()   

    useEffect(() => {
        let textData = ''

        if (payment?.fromPayPal) {
            textData = `This payment was processed externally by PayPal, with the following financial transaction data: \n ${payment?.paypalData?.raw}`
        } else {
            textData = "This payment was not processed by PayPal because the final transaction amount, considering the discount applied, was lower than the processing cost. Therefore, the user was considered a guest and authorized to use the apps."
        }

        setDetail(textData)
    },[payment])

    return (
        <>
            {/* Address */}
            <h6 className="heading-small text-muted mb-4">
                Management information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-detail"
                            >
                                Details
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={detail}
                                id="input-detail"
                                name="detail"
                                placeholder="Payment Details"
                                type="textarea"
                                rows="5"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                </Row>

            </div>

        </>
    )
}

export default ManagementInformation;